// extracted by mini-css-extract-plugin
module.exports = {"container-fluid":"container-fluid_container-fluid__txeSL"};